(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shaker-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shaker-buy')) {
    class ShakerBuy extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        const json = this.querySelector('[data-sl-variants]');
        this.variants = json ? JSON.parse(json.textContent) : [];
        this.form.addEventListener('change', (event) => {
          if (event.target.closest('[data-sl-option]')) this.onOptionChange();
        });
        this.form.addEventListener('click', (event) => {
          const step = event.target.closest('[data-sl-qty]');
          if (step) this.stepQuantity(Number(step.dataset.slQty));
        });
        this.form.addEventListener('submit', () => {
          const button = this.form.querySelector('[type="submit"]');
          if (button) button.setAttribute('aria-busy', 'true');
        });
      }

      stepQuantity(delta) {
        const input = this.form.querySelector('input[name="quantity"]');
        if (!input) return;
        const current = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, current + delta);
      }

      onOptionChange() {
        const selected = Array.from(this.form.querySelectorAll('[data-sl-option]')).map((group) => {
          const checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });
        const variant = this.variants.find((item) => item.options.every((value, index) => value === selected[index]));
        this.render(variant);
      }

      render(variant) {
        const root = this.closest('shaker-landing') || document;
        const available = Boolean(variant && variant.available);
        root.querySelectorAll('shaker-buy').forEach((buy) => {
          const form = buy.querySelector('form');
          if (!form) return;
          const button = form.querySelector('[type="submit"]');
          const label = form.querySelector('[data-sl-btn-label]');
          const idInput = form.querySelector('[data-sl-variant-id]');
          if (variant && idInput && idInput.value !== String(variant.id)) {
            idInput.value = variant.id;
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (button) button.disabled = !available;
          if (label) label.textContent = available ? buy.dataset.addText : buy.dataset.soldOutText;
        });
        if (!variant) return;
        root.querySelectorAll('[data-sl-price]').forEach((node) => {
          node.textContent = variant.price;
        });
        root.querySelectorAll('[data-sl-compare]').forEach((node) => {
          node.textContent = variant.compare;
          node.hidden = !variant.onSale;
        });
        root.querySelectorAll('[data-sl-save]').forEach((node) => {
          node.textContent = 'Ahorras ' + variant.save;
          node.hidden = !variant.onSale;
        });
        root.querySelectorAll('[data-sl-discount]').forEach((node) => {
          node.textContent = '−' + variant.percent + '%';
          node.hidden = !variant.onSale;
        });
      }
    }
    customElements.define('shaker-buy', ShakerBuy);
  }
  } catch(e) { console.error(e); }
})();

})();
